import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { APP_BASE_HREF, HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { LoginComponent } from './views/login/login.component';
import { HomeComponent } from './views/home/home.component';
import { TermsAndConditionsComponent } from './views/terms-and-conditions/terms-and-conditions.component';
import { CarouselComponent } from './views/carousel/carousel.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { FaqsComponent } from './views/faqs/faqs.component';
import { ModalPolityComponent } from './components/modals/modal-polity/modal-polity.component';
import { ModalTermsComponent } from './components/modals/modal-terms/modal-terms.component';
import { GlobalPositionComponent } from './views/global-position/global-position.component';
import { ReportComponent } from './views/global-position/report/report.component';
import { StatsComponent } from './views/global-position/stats/stats.component';
import { TipsComponent } from './views/global-position/tips/tips.component';
import { ErrorComponent } from './components/error/error.component';
import { UnsubscribeSuccessComponent } from './components/unsubscribe-success/unsubscribe-success.component';
import { SummaryComponent } from './views/global-position/summary/summary.component';
import { FaqsClientComponent } from './views/global-position/faqs-client/faqs-client.component';
import { EngagementComponent } from './views/engagement/engagement.component';
import { ManegementPortalComponent } from './views/manegement-portal/manegement-portal.component';
import { AdminPortalComponent } from './views/admin-portal/admin-portal.component';
import { ResumeEurobitsComponent } from './views/admin-portal/resume-eurobits/resume-eurobits.component';
import { UpdateParamsComponent } from './views/admin-portal/update-params/update-params.component';
import { AuditComponent } from './views/admin-portal/audit/audit.component';
import { LogsComponent } from './views/admin-portal/logs/logs.component';
import { ManualComponent } from './views/admin-portal/resume-eurobits/manual/manual.component';
import { AutoComponent } from './views/admin-portal/resume-eurobits/auto/auto.component';
import { CategoriesComponent } from './views/admin-portal/update-params/categories/categories.component';
import { ServiceComponent } from './views/admin-portal/update-params/service/service.component';
import { AdminEngagementComponent } from './views/admin-portal/update-params/engagement/engagement.component';
import { KpisAdminComponent } from './views/admin-portal/update-params/kpis-admin/kpis-admin.component';
import { MainComponent } from './views/global-position/summary/main/main.component';
import { DetailComponent } from './views/global-position/summary/detail/detail.component';
import { ModalCookiesComponent } from './components/modals/modal-cookies/modal-cookies.component';
import { SecurityComponent } from './views/security/security.component';
import { SigninComponent } from './views/signin/signin.component';
import { SigninSCFComponent } from './views/signin-scf/signin-scf.component';
import { UserSingInComponent } from './views/admin-portal/user-sing-in/user-sing-in.component';
import { ScoringComponent } from './views/scoring/scoring.component';
import { SettingsComponent } from './views/global-position/settings/settings.component';
import { Signin2Component } from './views/signin2/signin2.component';
import { ForgetPassComponent } from './views/signin2/forget-pass/forget-pass.component';
import { MultiLoginComponent } from './views/signin2/multi-login/multi-login.component';
import { TestComponent } from './views/test/test.component';
import { WidgetComponent } from './views/widget/widget.component';
import { AdminReportComponent } from './views/admin-portal/update-params/report/report.component';
import { TinkResponseComponent } from './views/tink-response/tink-response.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'startpage', component: CarouselComponent },
  { path: 'test', component: TestComponent },
  { path: 'home', component: HomeComponent },
  { path: 'terms', component: TermsAndConditionsComponent },
  { path: 'security', component: SecurityComponent },
  { path: 'login', component: LoginComponent },
  { path: 'signin', component: SigninComponent }, // , canActivate: ['routePermissions'] },
  {
    path: 'multi-signin', component: Signin2Component, children: [
      { path: '', redirectTo: 'main', pathMatch: 'full' },
      { path: 'main', component: MultiLoginComponent },
      { path: 'forget-pass', component: ForgetPassComponent },
    ]
  },
  { path: 'signinSCF', component: SigninSCFComponent },
  { path: 'widget', component: WidgetComponent },
  {
    path: 'global-position', component: GlobalPositionComponent, children: [
      { path: '', redirectTo: 'summary', pathMatch: 'full' },
      {
        path: 'summary', component: SummaryComponent, children: [
          { path: '', redirectTo: 'main', pathMatch: 'full' },
          { path: 'main', component: MainComponent },
          { path: 'detail', component: DetailComponent },
        ]
      },
      { path: 'stats', component: StatsComponent },
      { path: 'tips', component: TipsComponent },
      { path: 'report', component: ReportComponent },
      { path: 'faqs-client', component: FaqsClientComponent },
      { path: 'settings', component: SettingsComponent }
    ]
  },
  { path: 'faqs', component: FaqsComponent },
  { path: 'engagement', component: EngagementComponent },
  // { path: 'portalM', component: ManegementPortalComponent },
  { path: 'scoring', component: ScoringComponent },
  /*{
    path: 'admin', component: AdminPortalComponent, children: [
      // { path: '', redirectTo: 'manual', pathMatch: 'full' },
      { path: 'audit', component: AuditComponent },
      { path: 'logs', component: LogsComponent },
      { path: 'manual', component: ManualComponent },
      { path: 'auto', component: AutoComponent },
      { path: 'categories', component: CategoriesComponent },
      { path: 'kpis', component: KpisAdminComponent },
      { path: 'report', component: AdminReportComponent },
      { path: 'service', component: ServiceComponent },
      { path: 'adminEngagement', component: AdminEngagementComponent },
      { path: 'user-sign-in', component: UserSingInComponent }
    ]
  },*/
  { path: ':country/terms-conditions', component: ModalTermsComponent },
  { path: ':country/privacy-polity', component: ModalPolityComponent },
  { path: 'cookies', component: ModalCookiesComponent },
  { path: 'error', component: ErrorComponent },
  { path: 'unsubscribe', component: UnsubscribeSuccessComponent },
  { path: 'tink/response', component: TinkResponseComponent },
  { path: '**', component: PageNotFoundComponent }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: APP_BASE_HREF, useValue: '' }
  ]
})
export class AppRoutingModule { }
